import {ApiService} from '../../index';

export const getAllRejectedSample = () => {
    return ApiService.baseAction(
        'rejected-sample/list/all',
        {},
        'get'
    )
}